module.exports = __webpack_public_path__ + "img/destination-2.47ae78c5.svg";